import React from 'react';
import PropTypes from 'prop-types';

function PageHeading({ children }) {
  return <div className="ws-page-heading">{children}</div>;
}

PageHeading.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PageHeading;
